(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lcp-delivery-timeline"] && !Shopify.designMode) return;
  try {
    class LcpDeliveryTimeline extends HTMLElement {
    #timer;
    #refresh = () => {
      clearTimeout(this.#timer);
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(now);
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const today = Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day));
      const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', {
        timeZone: 'UTC', day: 'numeric', month: 'short'
      });
      this.querySelectorAll('[data-lcp-date-offset]').forEach(element => {
        const date = new Date(today + Number(element.dataset.lcpDateOffset) * 86400000);
        element.dateTime = date.toISOString().slice(0, 10);
        element.textContent = formatter.format(date);
      });
      const nextMidnight = today + 86400000 - 19800000;
      const minutes = Math.ceil(Math.max(0, nextMidnight - now.getTime()) / 60000);
      const hoursText = String(Math.floor(minutes / 60)).padStart(2, '0');
      const minutesText = String(minutes % 60).padStart(2, '0');
      const countdown = this.querySelector('[data-lcp-countdown]');
      if (countdown) {
        countdown.textContent = `${hoursText} ${this.dataset.lcpHours} ${minutesText} ${this.dataset.lcpMinutes}`;
      }
      if (!document.hidden) {
        this.#timer = setTimeout(this.#refresh, 60000 - now.getTime() % 60000 + 50);
      }
    };

    connectedCallback() {
      this.#refresh();
      document.addEventListener('visibilitychange', this.#refresh);
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
      document.removeEventListener('visibilitychange', this.#refresh);
    }
  }

  if (!customElements.get('lcp-delivery-timeline')) {
    customElements.define('lcp-delivery-timeline', LcpDeliveryTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
